import { Box, Typography } from '@mui/material';
import { FC, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	clearSwissDeclarations,
	downloadSwissDeclarationRequest,
	getSwissDeclarationsRequest,
} from 'redux/reducers/orderManagement/reducer';
import {
	selectSwissDeclarationDownloadLoading,
	selectSwissDeclarations,
	selectSwissDeclarationsLoading,
} from 'redux/reducers/orderManagement/selectors';
import { PAGE_SIZE } from 'services/constants/env';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'ui/EasTable/types';
import { tableStructure } from './tableStructure';
import { TSwissDeclarationsProps, TSwissDeclarationsRow } from './types';

export const SwissDeclarations: FC<TSwissDeclarationsProps> = ({ orderId }) => {
	const dispatch = useDispatch();
	const swissDeclarations = useSelector(selectSwissDeclarations);
	const swissDeclarationsLoader = useSelector(selectSwissDeclarationsLoading);
	const downloadLoading = useSelector(selectSwissDeclarationDownloadLoading);

	useEffect(() => {
		dispatch(
			getSwissDeclarationsRequest({
				orderId,
				pageSize: PAGE_SIZE,
				pageNumber: 1,
			}),
		);

		return () => {
			dispatch(clearSwissDeclarations());
		};
	}, [dispatch, orderId]);

	const handleAction = useCallback<THandleAction>(
		(id, action) => {
			if (action !== 'Download') return;

			const row = swissDeclarations?.data?.find((item) => item.id === id);
			if (!row) return;

			dispatch(
				downloadSwissDeclarationRequest({
					orderId,
					id,
					fileName: row.fileName,
				}),
			);
		},
		[dispatch, orderId, swissDeclarations],
	);

	return (
		<Box mt={1}>
			<EasTableWithoutFilter<TSwissDeclarationsRow>
				tableStructure={tableStructure}
				items={swissDeclarations}
				itemsIsLoading={swissDeclarationsLoader || downloadLoading}
				handleAction={handleAction}
				skeletonRows={[1]}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="body1" color="primary" fontWeight="bold">
						Swiss Declarations
					</Typography>
				</Box>
			</EasTableWithoutFilter>
		</Box>
	);
};
